import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from // fetchAudit
"@/api/PMS/performancecenter/theaterManage";
import Tinymce from "@/components/Tinymce";
export default {
  components: {
    Tinymce: Tinymce
  },
  props: {
    showDialog: Boolean,
    isDetail: Boolean,
    isAudit: Boolean,
    isDashboard: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    var _this = this;

    var fileMustUpload = function fileMustUpload(rule, value, callback) {
      console.log(_this.fileList, "sssss");

      if (_this.fileList.length === 0) {
        // 未上传文件
        callback("请上传活动封面");
      }

      callback();
    };

    return {
      rules: {
        activityTitle: [{
          required: true,
          message: "请输入活动名称",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "change"
        }],
        priceRange: [{
          required: true,
          message: "请输入价格区间",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "change"
        }],
        activityLocation: [{
          required: true,
          message: "请输入活动场地",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "change"
        }],
        files: [{
          required: true,
          validator: fileMustUpload,
          trigger: "blur"
        }],
        activityOption: [{
          required: true,
          message: "请输入活动内容",
          trigger: "change"
        }, {
          min: 1,
          max: 30000,
          message: "长度在 1 到 30000 个字符",
          trigger: "change"
        }],
        // activityId: [
        //   { required: true, message: "请选择项目类型", trigger: "change" }
        // ],
        activeDates: [{
          required: true,
          message: "请选择活动时间",
          trigger: "change"
        }],
        // isCharge: [
        //   { required: true, message: "请选择是否计费", trigger: "change" }
        // ],
        actiOrder: [{
          required: true,
          message: '请输入排序',
          trigger: 'change'
        }],
        // activityPlannedEnrollment: [
        //   { required: true, message: "请输入报名人数", trigger: "blur" },
        //   { required: true, message: "请输入报名人数", trigger: "change" }
        // ],
        registrationDates: [{
          required: true,
          message: "请选择报名时间",
          trigger: "change"
        }]
      },
      readonly: 1,
      activeDates: "",
      registrationDates: [],
      files: [],
      toolbar: [""],
      oldImgList: [],
      removeList: [],
      // activeTypeOption: [],
      uploadUrl: "",
      downloadUrl: "",
      addList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      childData: {},
      appType: "",
      isChargeOption: [{
        id: 0,
        value: "不计费"
      }, {
        id: 1,
        value: "计费"
      }],
      title: ""
    };
  },
  computed: {
    isBuildParty: function isBuildParty() {
      return this.$route.path.indexOf("partyactivityManage") > -1;
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD; // 获取路由的配置

    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.appType = parseInt(appType);
    }

    this.init(); // this.getTypeOption();
  },
  methods: {
    // changeCharge () {
    //   this.childData.changeActivityItemVos = [];
    //   if (this.childData.activityId == 1) {
    //     this.childData.isCharge = 0;
    //   } else if (this.childData.activityId == 2) {
    //     this.childData.isCharge = 1;
    //   } else if (this.childData.activityId == 3) {
    //     this.childData.isCharge = 0;
    //   }
    // },
    // handPass () {
    //   fetchAudit({ id: this.keyValue, state: 2 }).then(res => {
    //     if (res.data.code === 200) {
    //       this.$emit("handCancle", true);
    //       this.Alert({ alertType: "update", message: "审核通过" });
    //     }
    //   });
    // },
    // handUnPass () {
    //   fetchAudit({ id: this.keyValue, state: 3 }).then(res => {
    //     if (res.data.code === 200) {
    //       this.$emit("handCancle", true);
    //       this.Alert({ alertType: "update", message: "审核未通过" });
    //     }
    //   });
    // },
    // getTypeOption () {
    //   fetchList({ appType: this.appType, page: 1, limit: 9999 }).then(res => {
    //     if (res.data.code === 200) {
    //       this.activeTypeOption = res.data.data;
    //     }
    //   });
    // },
    init: function init() {
      var _this2 = this;

      this.fileList = [];
      this.files = [];
      this.addList = [];
      this.removeList = [];
      this.childData = {};
      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
          _this2.files = _this2.childData.activeFileListVoList.map(function (item) {
            return {
              fileId: item.fileId,
              name: item.fileName,
              url: item.fileId
            };
          });
          _this2.fileList = _this2.files;

          _this2.$set(_this2.childData, "activeDates", [_this2.childData.activityBeginDate, _this2.childData.activityEndDate]);

          _this2.$set(_this2.childData, "registrationDates", [_this2.childData.enrollmentBeginDate, _this2.childData.enrollmentEndDate]);

          var that = _this2;
          setTimeout(function () {
            that.$refs["editor"].setContent(that.childData.activityOption);
            that.$refs["viewer"].setContent(that.childData.activityOption);
          }, 100);
        });
      } else {
        // this.childData = {
        //   changeActivityItemVos: []
        // };
        // this.$set(this.childData, "activeDates", []);
        // this.$set(this.childData, "registrationDates", []);
        setTimeout(function () {
          _this2.$refs["editor"].setContent("");

          if (_this2.isDetail) _this2.$refs["viewer"].setContent("");
        }, 100);
      }
    },
    handleActiveDates: function handleActiveDates(val) {
      if (val && this.childData.registrationDates && this.childData.registrationDates.length > 0) {
        var registrationEndTime = new Date(this.childData.registrationDates[1]).getTime(); //  报名结束时间

        var activeBeginTime = new Date(val[0]).getTime() - 3600 * 8 * 1000; // 活动开始时间

        if (activeBeginTime < registrationEndTime) {
          this.$message.error("活动开始时间必须在报名结束时间之后");
          this.$set(this.childData, "activeDates", []);
        }
      }
    },
    handleRegistrationDate: function handleRegistrationDate(val) {
      if (val && this.childData.activeDates && this.childData.activeDates.length > 0) {
        var activeBeginTime = new Date(this.childData.activeDates[0]).getTime() - 3600 * 8 * 1000; // 活动开始时间

        var registrationEndTime = new Date(val[1]).getTime(); // 报名结束时间

        if (registrationEndTime > activeBeginTime) {
          this.$message.error("报名结束时间必须在活动开始时间之前");
          this.$set(this.childData, "registrationDates", []);
        }
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this3.childData.activityBeginDate = _this3.childData.activeDates[0];
          _this3.childData.activityEndDate = _this3.childData.activeDates[1];

          if (!_this3.isBuildParty) {
            _this3.childData.enrollmentBeginDate = _this3.childData.registrationDates[0];
            _this3.childData.enrollmentEndDate = _this3.childData.registrationDates[1];
          }

          if (!_this3.childData.activityOption) {
            _this3.Alert({
              alertType: "valid",
              message: "活动内容不能为空"
            });

            return;
          }

          _this3.childData.changeActiveFileVos = _this3.fileList;

          if (_this3.isBuildParty) {//this.childData.appType = 0
          } else {//this.childData.appType = 1
            }

          _this3.$set(_this3.childData, "isCharge", 1);

          _this3.$set(_this3.childData, "activityId", 4);

          if (_this3.keyValue > 0) {
            _this3.childData.changeNoticeFileVos = _this3.addList; //this.childData.deleteNoticeFileVo = { ids: this.removeList }

            fetchUpdate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit("handCancle", true);

                _this3.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            _this3.childData.appType = _this3.appType;
            _this3.childData.activeFileListVoList = _this3.fileList;
            fetchCreate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit("handCancle", true);

                _this3.Alert({
                  alertType: "add"
                });
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", "repairAdd");
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        fileId: file.response.data[0].fileId,
        name: file.response.data[0].fileName
      });
    },
    handleError: function handleError(err, file) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: "error"
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.name.includes("png") || file.name.includes("jpg") || file.name.includes("jpeg")) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.name.includes("png") || file.name.includes("jpg") || file.name.includes("jpeg")) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: "最多只能上传1个文件!",
        type: "danger"
      });
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === "jpg" || extension === "jpeg" || extension === "png" || extension === "gif";

      if (!fileFormatOK) {
        this.$message({
          message: "只支持上传 jpg/png/gif 格式文件!",
          type: "error"
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 10MB!",
          type: "error"
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var _this4 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
      }

      console.log("移除前", this.fileList);
      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this4.fileList.splice(index, 1);

          return;
        }
      });
      console.log("移除后", this.fileList);
      this.oldImgList.forEach(function (col, n) {
        if (currentUrl === col.filePath) {
          _this4.removeList.push(col.fileId);

          return;
        }
      });
      this.addList.forEach(function (item, index) {
        if (item.filePath === currentUrl) {
          _this4.addList.splice(index, 1);
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    }
  }
};